import { IDonorConnect } from '@nkr/models/donor-connect';

export interface IDuplicate extends IDonorConnect {
    newMentorId: number,
    changed: boolean
}